"use client";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollSmoother } from "@/lib/plugins";
import ScrollTrigger from "gsap/ScrollTrigger";
import { usePathname } from "next/navigation";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const ScrollSmootherComponent = () => {
  const pathname = usePathname();

  useGSAP(() => {
    try {
      const smoother = ScrollSmoother.get();
      if (smoother) {
        // If smoother already exists, just reset position
        smoother.scrollTop(0);
      } else {
        // Initial creation
        let device_width = window.innerWidth;
        ScrollSmoother.create({
          smooth: 1,
          effects: device_width < 1025 ? false : true,
          smoothTouch: false,
          normalizeScroll: false, // Disabled to prevent interaction lockups after idle state
          ignoreMobileResize: true,
        });
      }

      // Refresh ScrollTrigger after a small delay to ensure page height is updated
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);

    } catch (e) {
      console.log("scrollSmootherError", e);
    }
  }, [pathname]);

  return null;
};

export default ScrollSmootherComponent;
